import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Version change aana pazhaya localStorage clear aagum
const APP_VERSION = 'v1.3';
const storedVersion = localStorage.getItem('vflow_version');
if (storedVersion !== APP_VERSION) {
  localStorage.clear();
  localStorage.setItem('vflow_version', APP_VERSION);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
